import React from 'react';
import './Button.css';

/**
 * Button Component
 * @param {string}  variant    - 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline'
 * @param {string}  size       - 'sm' | 'md' | 'lg'
 * @param {node}    icon       - optional icon element (left)
 * @param {node}    iconRight  - optional icon element (right)
 * @param {boolean} loading    - show spinner
 * @param {boolean} disabled
 * @param {boolean} fullWidth
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconRight,
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...rest
}) => {
  const classes = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    fullWidth ? 'btn--full' : '',
    loading  ? 'btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      {loading && <span className="btn__spinner" aria-hidden="true" />}
      {!loading && icon && <span className="btn__icon btn__icon--left">{icon}</span>}
      {children && <span className="btn__label">{children}</span>}
      {!loading && iconRight && <span className="btn__icon btn__icon--right">{iconRight}</span>}
    </button>
  );
};

export default Button;
